export enum PowerBankActionTypes {
  API_RESPONSE_SUCCESS = "@@powerbank/API_RESPONSE_SUCCESS",
  API_RESPONSE_ERROR = "@@powerbank/API_RESPONSE_ERROR",

  GET_POWERBANKS = "@@powerbank/GET_POWERBANKS",
  ADD_POWERBANKS = "@@powerbank/ADD_POWERBANKS",
  UPDATE_POWERBANKS = "@@powerbank/UPDATE_POWERBANKS",
  DELETE_POWERBANKS = "@@powerbank/DELETE_POWERBANKS",
}
